import React, { useEffect, useState } from "react";
import * as S from "./styles";

const pad = (value) => String(value).padStart(2, "0");

const getTimeRemaining = (target) => {
  const total = target - Date.now();

  if (total <= 0) {
    return { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  return {
    total,
    days: Math.floor(total / (1000 * 60 * 60 * 24)),
    hours: Math.floor((total / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((total / 1000 / 60) % 60),
    seconds: Math.floor((total / 1000) % 60),
  };
};

const WaitingCard = ({
  badgeLabel = "SIMULADO ENVIADO",
  title = "Boa, atleta. Seu jogo foi registrado.",
  subtitle = "Seu gabarito completo + a correção em vídeo saem sexta, 05/06 às 18h.\n Até lá, nada de spoilers 👀",
  releaseDate,
  counterLabel = "RESULTADO LIBERA EM",
  noticeIcon = "📱",
  noticeText = "A gente te avisa no WhatsApp assim que liberar.",
  whatsappUrl,
  whatsappLabel = "Ainda não entrou no grupo? Entrar no WhatsApp",
  whatsappHint = "Já participa de um grupo? Então pode relaxar — você já vai receber tudo lá.",
  onComplete,
}) => {
  const targetTime = releaseDate ? new Date(releaseDate).getTime() : null;
  const [timeLeft, setTimeLeft] = useState(() =>
    targetTime ? getTimeRemaining(targetTime) : null,
  );

  useEffect(() => {
    if (!targetTime) return undefined;

    let intervalId;
    const tick = () => {
      const next = getTimeRemaining(targetTime);
      setTimeLeft(next);

      if (next.total <= 0) {
        clearInterval(intervalId);
        if (typeof onComplete === "function") onComplete();
      }
    };

    tick();
    intervalId = setInterval(tick, 1000);

    return () => clearInterval(intervalId);
  }, [targetTime, onComplete]);

  return (
    <S.Card>
      <S.Badge>
        <S.BadgeCheck>✓</S.BadgeCheck>
        <S.BadgeText>{badgeLabel}</S.BadgeText>
      </S.Badge>

      <S.Title>{title}</S.Title>

      {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}

      {timeLeft && (
        <S.CounterBox>
          <S.CounterLabel>{counterLabel}</S.CounterLabel>
          <S.CounterRow>
            <S.CounterCell>
              <S.CounterValue>{pad(timeLeft.days)}</S.CounterValue>
              <S.CounterUnit>DIAS</S.CounterUnit>
            </S.CounterCell>
            <S.CounterSeparator>:</S.CounterSeparator>
            <S.CounterCell>
              <S.CounterValue>{pad(timeLeft.hours)}</S.CounterValue>
              <S.CounterUnit>HORAS</S.CounterUnit>
            </S.CounterCell>
            <S.CounterSeparator>:</S.CounterSeparator>
            <S.CounterCell>
              <S.CounterValue>{pad(timeLeft.minutes)}</S.CounterValue>
              <S.CounterUnit>MIN</S.CounterUnit>
            </S.CounterCell>
            <S.CounterSeparator>:</S.CounterSeparator>
            <S.CounterCell>
              <S.CounterValue>{pad(timeLeft.seconds)}</S.CounterValue>
              <S.CounterUnit>SEG</S.CounterUnit>
            </S.CounterCell>
          </S.CounterRow>
        </S.CounterBox>
      )}

      {noticeText && (
        <S.Notice>
          {noticeIcon && <S.NoticeIcon>{noticeIcon}</S.NoticeIcon>}
          <S.NoticeText>{noticeText}</S.NoticeText>
        </S.Notice>
      )}

      {whatsappUrl && (
        <S.WhatsAppSection>
          <S.WhatsAppButton
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {whatsappLabel}
          </S.WhatsAppButton>
          {whatsappHint && <S.WhatsAppHint>{whatsappHint}</S.WhatsAppHint>}
        </S.WhatsAppSection>
      )}
    </S.Card>
  );
};

export default WaitingCard;
